import { original } from '@reduxjs/toolkit'
import { random } from 'underscore'
import { ChainIcon } from '../../../../assets/icons/chain'
import { FileWithArrowUp } from '../../../../assets/icons/fileWithArrowUp'
import { TextWithFile } from '../../../../pages/Interpretations/[id]/Interpretations.style'
import { SignalLevel } from '../../../customStyledElements'
import { THead } from '../../main/indicators-signals-table/IndicatorsSignalTable'
import {EmptyTable, getScaleTypeByIndex} from '../../../../pages/subjects/Subject'
import { MAX_URL_LENGTH } from '../../../../pages/subjects/SubjectEdit'
import {useAppSelector} from "../../../../hooks/redux";
import {Link} from "react-router-dom";
import {getSubjectId} from "../../../../pages/biomarkers/[id]/IndicatorsAndSignals";
import {RemoveBtn} from "../../../listMenu/listMenu";
import React from "react";
import {InfinityIcon} from "../../../../assets/icons/infinityIcon";
import getUnitType from "../../typeName";

export const Empty = () => {
  return <EmptyTable name={'biomarker'}/>
}

export const NothingFound = () => {
  return (
    <tr>
      <td colSpan={1000} className={'nothing-found'}>
        Nothing Found ....
      </td>
    </tr>
  )
}

export const IdInterpretationsHead = () => {
  return (
    <THead>
      <tr>
        <td>Signal name</td>
        <td>Unit</td>
        <td style={{width: '30%'}}>RAG Signals</td>
        <td>Parent Indicator</td>
      </tr>
    </THead>
  )
}

export const IdInterpretationsBody = ({ item, ind }: any) => {
  const {indicators} = useAppSelector((state) => state.data)

  let {indicator, signal, signalByCheckboxes, onRemove} = item;
  
  // Проверяем что indicator существует и имеет signals
  if (!indicator || !indicator.signals) {
    return (
      <tbody>
        <tr>
          <td colSpan={1000} className={'nothing-found'}>
            No indicator data available
          </td>
        </tr>
      </tbody>
    )
  }
  
  let linkTo = '/' + getSubjectId() + '/biomarkers/' + indicator._id;
  let signals = (Object.keys(signalByCheckboxes) || []).map(signalIndex => {
    let nextSignal = indicator.signals[+signalIndex + 1]
    let it = indicator.signals[+signalIndex];
    return {...it, valueTo: nextSignal?.valueFrom, signalIndex: +signalIndex, name: it?.name || `Signal #${+signalIndex + 1}`}
  })

  let name = signals.map(it => it.name).join(', ')
  // let name = indicator?.name;
  console.log("qqqqq indicator UT", indicator);
  
  // Дополнительная проверка для name
  if (!name) {
    name = 'No signals available'
  }
  return (
    <tbody>
      <tr>
        <td>
          <Link to={linkTo}>
            <TextWithFile>
              <FileWithArrowUp />
              <p>
                {name?.slice(0, MAX_URL_LENGTH)}
                {name?.slice(MAX_URL_LENGTH)?.length > 0 && '...'}
              </p>
            </TextWithFile>
          </Link>
        </td>
        <td>
          <p>{getUnitType(indicator)}</p>
        </td>
        <td>
          <Link to={linkTo} data-notext style={{ display: 'flex', alignItems: 'center', overflow: 'auto' }}>
            {signals.map((signal, ind) => {
              let {color} = getScaleTypeByIndex(indicator, signal?.signalIndex);

                return (<div key={ind} className={'ib'}>
                  <SignalLevel color={color}>{signal.valueFrom} - {signal.valueTo || '∞'} </SignalLevel>
                </div>)
            })}


          </Link>
        </td>
        <td>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to={linkTo}>
            <ChainIcon style={{ marginRight: '5px', marginBottom: '-5px' }} />
            {typeof indicator?.name === 'object' 
                ? indicator.name?.en || indicator.name?.[Object.keys(indicator.name || {})[0]] || ''
                : indicator?.name || ''}
            </Link>
          </div>
        </td>
      </tr>
    </tbody>
  )
}
